module.exports = __webpack_public_path__ + "img/attachment.b3a22fae.png";